import { Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo } from "react";
import { useParams } from "react-router";
import { ArchivedEntityClippingList } from "../../clippings/ArchivedEntityClippingList";
import { entityClippingsService } from "../../shared/api/clippingsService";
import { companyService } from "../../shared/api/companyService";

export const ArchivedCompanyClippingList: FC = () => {
	const { id = "" } = useParams<"id">();
	const service = useMemo(() => entityClippingsService("companies", id), [id]);

	const { data: company, isLoading: isContactLoading } = useQuery({
		queryKey: companyService.showKey(id),
		queryFn: () => companyService.show(id).then((res) => res.data.data),
	});

	if (isContactLoading || !company) {
		return <Loading />;
	}

	return <ArchivedEntityClippingList service={service} />;
};
